<template>
  <body>
    <div class="body">
      <div>
        <div class="text">
          Product overview <br />
          <span>For brands</span>
        </div>
        <div class="image-wrapper">
          <img class="image" :src="currentImage" alt="product-overview" />
        </div>
      </div>
      <div class="arrow-wrapper">
        <img
          class="arrow"
          src="../../../assets/ProductOverviewBrands/swipe-right-brands.svg"
          alt="swipe-right"
          @click="nextImage"
        />
      </div>
      <div class="body-mobile">
        <img
          class="mobile-image"
          src="../../../assets/ProductOverviewBrands/mobileScreens/mobile-brand-one.png"
          alt="mobile-one"
        />
        <img
          class="mobile-image"
          src="../../../assets/ProductOverviewBrands/mobileScreens/mobile-brand-two.png"
          alt="mobile-one"
        />
        <img
          class="mobile-image"
          src="../../../assets/ProductOverviewBrands/mobileScreens/mobile-brand-three.png"
          alt="mobile-one"
        />
        <img
          class="mobile-image"
          src="../../../assets/ProductOverviewBrands/mobileScreens/mobile-brand-four.png"
          alt="mobile-one"
        />
      </div>
    </div>
  </body>
</template>

<script>
export default {
  name: "ProductOverviewBrands",
  data() {
    return {
      images: [
        require("../../../assets/ProductOverviewBrands/ProductOverviewBrands.png"),
        require("../../../assets/ProductOverviewBrands/ProductOverviewBrands2.png"),
      ],
      currentIndex: 0,
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentIndex];
    },
  },
  methods: {
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
  },
};
</script>

<style scoped>
.body {
  width: 100%;
  height: fit-content;
  background: #343434;
  border-radius: 22px;
  overflow: hidden;
  display: flex;
  align-items: center;
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
}
.text {
  font-size: 45px;
  font-weight: 700;
  max-width: 450px;
  margin: 37px 0px 0px 96px;
  color: #ffffff;
  line-height: 1.2;
}
.image {
  width: 100%;
  height: 100%;
}
span {
  color: #eb4dbf;
}
.arrow-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  padding-right: 40px;
}
.arrow {
  width: 41px;
  height: 83px;
  cursor: pointer;
}
.body-mobile {
  display: none;
  width: 100%;
  height: 100%;
  padding: 0px 0px 66px 105px;
}
.mobile-image {
  width: 225px;
  height: 481px;
}
@media (max-width: 1024px) {
  .text {
    font-size: 35px;
    margin: 28px 0px 0px 36px;
  }
}

@media (max-width: 744px) {
  .body {
    width: 100%;
    height: fit-content;
    flex-direction: column;
    align-items: flex-start;
    gap: 74px;
  }
  .body-mobile {
    display: block;
    display: flex;
    gap: 50px;
    overflow-x: scroll;
    scroll-snap-type: x mandatory;
    padding: 0px 20px 66px 55px;
    box-sizing: border-box;
  }
  .image-wrapper,
  .arrow-wrapper {
    display: none;
  }
  .mobile-image {
    scroll-snap-align: center;
    flex: 0 0 auto;
  }
  .text {
    font-size: 25px;
  }
}
</style>
